import { render, staticRenderFns } from "./TsHandleHis.vue?vue&type=template&id=5343cf2e&scoped=true&"
import script from "./TsHandleHis.vue?vue&type=script&lang=js&"
export * from "./TsHandleHis.vue?vue&type=script&lang=js&"
import style1 from "./TsHandleHis.vue?vue&type=style&index=1&id=5343cf2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343cf2e",
  null
  
)

export default component.exports